<div class="tipification-drawer">
  <div class="drawer-header">
    <h2 class="drawer-title">Tipificar</h2>
    <button class="close-button" (click)="close()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4969 5L7.3302 5C6.87187 5 6.49687 5.375 6.49687 5.83333C6.49687 6.29167 6.87187 6.66667 7.3302 6.66667L16.4969 6.66667C16.9552 6.66667 17.3302 6.29167 17.3302 5.83333C17.3302 5.375 16.9552 5 16.4969 5ZM16.4969 9.16667L9.8302 9.16667C9.37187 9.16667 8.99687 9.54167 8.99687 10C8.99687 10.4583 9.37187 10.8333 9.8302 10.8333L16.4969 10.8333C16.9552 10.8333 17.3302 10.4583 17.3302 10C17.3302 9.54167 16.9552 9.16667 16.4969 9.16667ZM17.3302 14.1667C17.3302 13.7083 16.9552 13.3333 16.4969 13.3333L7.3302 13.3333C6.87187 13.3333 6.49687 13.7083 6.49687 14.1667C6.49687 14.625 6.87187 15 7.3302 15L16.4969 15C16.9552 15 17.3302 14.625 17.3302 14.1667ZM2.91354 7.6L5.31353 10L2.91353 12.4C2.58853 12.725 2.58853 13.25 2.91353 13.575C3.23853 13.9 3.76353 13.9 4.08853 13.575L7.0802 10.5833C7.4052 10.2583 7.4052 9.73333 7.0802 9.40833L4.08854 6.41667C3.76354 6.09167 3.23854 6.09167 2.91354 6.41667C2.59687 6.74167 2.58854 7.275 2.91354 7.6Z"
          fill="#0C6AA8"
        />
      </svg>
    </button>
  </div>

  <form [formGroup]="form" class="drawer-content">
    @if (state.isError() || hasPersistedError()) {
      <div class="alert-banner alert-error" role="alert">
        <div class="alert-content">
          <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6336 6.37894L9.56843 8.44412L7.50324 6.37894L6.37895 7.50323L8.44414 9.56841L6.37895 11.6336L7.50324 12.7579L9.56843 10.6927L11.6336 12.7579L12.7579 11.6336L10.6927 9.56841L12.7579 7.50323L11.6336 6.37894ZM9.56843 1.59473C5.15898 1.59473 1.59474 5.15896 1.59474 9.56841C1.59474 13.9779 5.15898 17.5421 9.56843 17.5421C13.9779 17.5421 17.5421 13.9779 17.5421 9.56841C17.5421 5.15896 13.9779 1.59473 9.56843 1.59473ZM9.56843 15.9474C6.05203 15.9474 3.18948 13.0848 3.18948 9.56841C3.18948 6.05202 6.05203 3.18946 9.56843 3.18946C13.0848 3.18946 15.9474 6.05202 15.9474 9.56841C15.9474 13.0848 13.0848 15.9474 9.56843 15.9474Z" fill="#F44336"/>
            </svg>
          </div>
          <div class="alert-text-wrapper">
            <div class="alert-title">Hubo un error al tipificar</div>
            <div class="alert-description">Hemos tenido inconvenientes con esta interacción por favor repórtalo inmediatamente.</div>
          </div>
        </div>
      </div>
    }

    @if (state.isSuccess() || hasPersistedSuccess()) {
      <div class="alert-banner alert-success" role="alert">
        <div class="alert-content">
          <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.56841 1.59473C5.16694 1.59473 1.59473 5.16694 1.59473 9.56841C1.59473 13.9699 5.16694 17.5421 9.56841 17.5421C13.9699 17.5421 17.5421 13.9699 17.5421 9.56841C17.5421 5.16694 13.9699 1.59473 9.56841 1.59473ZM9.56841 15.9474C6.05202 15.9474 3.18946 13.0848 3.18946 9.56841C3.18946 6.05202 6.05202 3.18946 9.56841 3.18946C13.0848 3.18946 15.9474 6.05202 15.9474 9.56841C15.9474 13.0848 13.0848 15.9474 9.56841 15.9474ZM13.2283 6.04404L7.97367 11.2987L5.90849 9.24149L4.7842 10.3658L7.97367 13.5553L14.3526 7.17631L13.2283 6.04404Z" fill="#7DE840"/>
            </svg>
          </div>
          <div class="alert-text-wrapper">
            <div class="alert-title">Interacción tipificada</div>
            <div class="alert-description">{{ getFormattedDateTime() }}</div>
          </div>
        </div>
      </div>
    }

    <div class="section">
      <div class="section-header">
        <div class="section-title-wrapper">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1.33337H3.99996C3.26663 1.33337 2.66663 1.93337 2.66663 2.66671V13.3334C2.66663 14.0667 3.26663 14.6667 3.99996 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V2.66671C13.3333 1.93337 12.7333 1.33337 12 1.33337ZM5.99996 2.66671H7.33329V6.00004L6.66663 5.50004L5.99996 6.00004V2.66671ZM12 13.3334H3.99996V2.66671H4.66663V8.66671L6.66663 7.16671L8.66663 8.66671V2.66671H12V13.3334Z"
              fill="#064C79"
            />
          </svg>
          <h3 class="section-title">TIPIFICAR</h3>
        </div>
      </div>

      <div class="section-content">
        <app-select
          [options]="state.reasonOptions()"
          label="Motivo"
          placeholder="Seleccionar"
          formControlName="motivo"
          [searchable]="true"
          [readOnly]="isReadOnly()"
        >
        </app-select>

        <div class="switch-row">
          <span class="switch-label">Solucionado en interacción</span>
          <app-switch formControlName="solucionadoEnInteraccion" [disabled]="isReadOnly()"></app-switch>
        </div>

        <div class="switch-row">
          <span class="switch-label">Incidencia generada</span>
          <app-switch formControlName="incidenciaGenerada" [disabled]="isReadOnly()"></app-switch>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-header collapsible" (click)="toggleGeneralInfo()">
        <div class="section-title-wrapper">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1.33337H3.99996C3.26663 1.33337 2.66663 1.93337 2.66663 2.66671V13.3334C2.66663 14.0667 3.26663 14.6667 3.99996 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V2.66671C13.3333 1.93337 12.7333 1.33337 12 1.33337ZM5.99996 2.66671H7.33329V6.00004L6.66663 5.50004L5.99996 6.00004V2.66671ZM12 13.3334H3.99996V2.66671H4.66663V8.66671L6.66663 7.16671L8.66663 8.66671V2.66671H12V13.3334Z"
              fill="#064C79"
            />
          </svg>
          <h3 class="section-title">INFORMACIÓN GENERAL</h3>
        </div>
        <svg
          class="expand-icon"
          [class.expanded]="isGeneralInfoExpanded()"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4.5 6.22L9 10.72L13.5 6.22"
            stroke="#064C79"
            stroke-width="2"
          />
        </svg>
      </div>

      @if (isGeneralInfoExpanded()) {
      <div class="section-content">
        <app-select
          [options]="vendedorOptions"
          label="Vendedor"
          placeholder="Seleccionar"
          formControlName="vendedor"
          [readOnly]="isReadOnly()"
        >
          <ng-template let-option="option">
            <div class="vendedor-option-content">
              <div class="tenant-circle" [style.background-color]="getVendorColor(option.value)"></div>
              <span class="option-label">{{ option.label }}</span>
            </div>
          </ng-template>
        </app-select>

        <app-select
          [options]="tiendaOptions"
          label="Tienda"
          formControlName="tienda"
          [readOnly]="isReadOnly()"
        >
        </app-select>

        @if (shouldUseStoreSelector()) {
          <app-store-selector
            label="Subtienda"
            placeholder="Seleccionar tienda"
            formControlName="subtienda"
            class="w-full"
            [searchable]="true"
            [disabled]="isReadOnly()"
          >
          </app-store-selector>
        } @else {
          <app-select
            [options]="subtiendaOptions"
            label="Subtienda"
            placeholder="Seleccionar"
            formControlName="subtienda"
            [readOnly]="isReadOnly()"
          >
          </app-select>
        }
      </div>
      }
    </div>

    <div class="section">
      <div class="section-header collapsible" (click)="toggleObservations()">
        <div class="section-title-wrapper">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 1.33337H3.99996C3.26663 1.33337 2.66663 1.93337 2.66663 2.66671V13.3334C2.66663 14.0667 3.26663 14.6667 3.99996 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V2.66671C13.3333 1.93337 12.7333 1.33337 12 1.33337ZM5.99996 2.66671H7.33329V6.00004L6.66663 5.50004L5.99996 6.00004V2.66671ZM12 13.3334H3.99996V2.66671H4.66663V8.66671L6.66663 7.16671L8.66663 8.66671V2.66671H12V13.3334Z"
              fill="#064C79"
            />
          </svg>
          <h3 class="section-title">OBSERVACIONES</h3>
        </div>
        <svg
          class="expand-icon"
          [class.expanded]="isObservationsExpanded()"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4.5 6.22L9 10.72L13.5 6.22"
            stroke="#064C79"
            stroke-width="2"
          />
        </svg>
      </div>

      @if (isObservationsExpanded()) {
      <div class="section-content">
        <textarea
          class="observations-textarea"
          [class.readonly]="isReadOnly()"
          [readOnly]="isReadOnly()"
          formControlName="observaciones"
          placeholder="Escribe aquí..."
          rows="6"
        >
        </textarea>
      </div>
      }
    </div>
  </form>

  <div class="drawer-footer">
    @if (!state.isSuccess() && !hasPersistedSuccess()) {
      <button
        horusBtn
        horusBtnSize="md"
        class="submit-button w-full"
        [disabled]="!isFormValid()"
        (click)="submit()"
      >
        TIPIFICAR
      </button>
    }
  </div>
</div>
